import { render, staticRenderFns } from "./UserMsg.vue?vue&type=template&id=f99a10b6&scoped=true"
import script from "./UserMsg.vue?vue&type=script&lang=js"
export * from "./UserMsg.vue?vue&type=script&lang=js"
import style0 from "./UserMsg.vue?vue&type=style&index=0&id=f99a10b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f99a10b6",
  null
  
)

export default component.exports